
import React, { useState, useRef, useEffect } from "react";
import {
  FaWhatsapp,
  FaTimes,
  FaPaperPlane
} from "react-icons/fa";

import "./WhatsAppBot.css";

const WHATSAPP_PHONE = "972507575775";

const topics = [
  "גירושין והליכי פרידה",
  "משמורת ילדים וזמני שהות",
  "מזונות ילדים",
  "חלוקת רכוש בין בני זוג",
  "הסכם ממון",
  "הסכם גירושין",
  "ידועים בציבור",
  "אלימות במשפחה",
  "ירושה וצוואות",
  "ייפוי כוח מתמשך",
  "נושא אחר"
];

const welcomeMessage = `שלום וברוכים הבאים 👋

אני העוזר הדיגיטלי של משרד עורכי הדין רז יוסף.

נשמח לקבל מספר פרטים ראשוניים כדי שנוכל להבין את פנייתך ולחזור אליך בהקדם.

לתשומת לבך: אין לשלוח בצ'אט מידע רפואי, מסמכים או פרטים משפטיים רגישים.`;

const initialMessages = [
  {
    type: "bot",
    text: welcomeMessage
  },
  {
    type: "bot",
    text: "באיזה נושא משפטי נוכל לסייע לך?"
  }
];

export default function WhatsAppBot() {
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [messages, setMessages] = useState(initialMessages);
  const [input, setInput] = useState("");

  const [answers, setAnswers] = useState({
    topic: "",
    city: "",
    name: "",
    phone: ""
  });

  const [processing, setProcessing] = useState(false);
  const [finished, setFinished] = useState(false);

  const messagesRef = useRef(null);
  const timerRef = useRef(null);
  const answersRef = useRef(answers);
  const finishedRef = useRef(false);

  useEffect(() => {
    answersRef.current = answers;
  }, [answers]);

  useEffect(() => {
    finishedRef.current = finished;
  }, [finished]);

  useEffect(() => {
    if (messagesRef.current) {
      messagesRef.current.scrollTop =
        messagesRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  function addBotMessage(text) {
    setMessages(prev => [
      ...prev,
      {
        type: "bot",
        text
      }
    ]);
  }

  function addUserMessage(text) {
    setMessages(prev => [
      ...prev,
      {
        type: "user",
        text
      }
    ]);
  }

  function moveToNextStep(nextStep, question) {
    timerRef.current = setTimeout(() => {
      setStep(nextStep);
      addBotMessage(question);
      setProcessing(false);
    }, 400);
  }

  function selectOption(topic) {
    if (step !== 1 || processing || finished) return;

    setProcessing(true);

    setAnswers(prev => ({
      ...prev,
      topic
    }));

    addUserMessage(topic);

    moveToNextStep(
      2,
      "נשמח לדעת באיזו עיר אתה נמצא."
    );
  }

  function sendMessage() {
    const value = input.trim();

    if (!value || processing || finished) return;

    if (step === 2) {
      const validCity = /^[א-תa-zA-Z\s'-]{2,}$/;

      if (!validCity.test(value)) {
        addBotMessage("נא להזין שם עיר תקין.");
        return;
      }

      setProcessing(true);

      setAnswers(prev => ({
        ...prev,
        city: value
      }));

      addUserMessage(value);
      setInput("");

      moveToNextStep(
        3,
        "מה שמך המלא?"
      );

      return;
    }

    if (step === 3) {
      const validName = /^[א-תa-zA-Z\s'-]{2,}$/;

      if (!validName.test(value)) {
        addBotMessage("נא להזין שם מלא תקין.");
        return;
      }

      setProcessing(true);

      setAnswers(prev => ({
        ...prev,
        name: value
      }));

      addUserMessage(value);
      setInput("");

      moveToNextStep(
        4,
        "מה מספר הטלפון שלך?"
      );

      return;
    }

    if (step === 4) {
      const cleanPhone = value.replace(/\D/g, "");

      if (!/^05\d{8}$/.test(cleanPhone)) {
        addBotMessage(
          "מספר הטלפון אינו תקין. נא להזין מספר ישראלי תקין, לדוגמה: 0501234567"
        );
        return;
      }

      const updatedAnswers = {
        ...answersRef.current,
        phone: cleanPhone
      };

      answersRef.current = updatedAnswers;

      setAnswers(updatedAnswers);
      addUserMessage(cleanPhone);
      setInput("");
      setProcessing(true);
      setStep(5);
      setFinished(true);

      finishedRef.current = true;

      timerRef.current = setTimeout(() => {
        addBotMessage(
          "תודה רבה על פנייתך למשרד עורכי הדין רז יוסף.\n\nהפרטים הראשוניים התקבלו. כעת ניתן לשלוח את הפנייה למשרד באמצעות כפתור הוואטסאפ."
        );

        setProcessing(false);
      }, 400);
    }
  }

  function sendWhatsapp() {
    if (!finishedRef.current || processing) return;

    const currentAnswers = answersRef.current;

    if (
      !currentAnswers.topic ||
      !currentAnswers.city ||
      !currentAnswers.name ||
      !currentAnswers.phone
    ) {
      addBotMessage("חסרים פרטים בפנייה. נא להשלים את התהליך.");
      return;
    }

    const text = `
פנייה חדשה מאתר משרד עורכי הדין רז יוסף

נושא הפנייה: ${currentAnswers.topic}

עיר: ${currentAnswers.city}

שם: ${currentAnswers.name}

טלפון: ${currentAnswers.phone}

הפונה מבקש לחזור אליו בבקשה
`;

    const url =
      `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(text)}`;

    window.open(url, "_blank", "noopener,noreferrer");

    finishedRef.current = false;
    setFinished(false);

    addBotMessage(
      "תודה רבה על פנייתך למשרד עורכי הדין רז יוסף.\n\nהמשך יום נעים."
    );

    timerRef.current = setTimeout(() => {
      resetChat();
    }, 40000);
  }

  function resetChat() {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    const emptyAnswers = {
      topic: "",
      city: "",
      name: "",
      phone: ""
    };

    answersRef.current = emptyAnswers;
    finishedRef.current = false;

    setStep(1);
    setInput("");
    setAnswers(emptyAnswers);
    setMessages(initialMessages);
    setProcessing(false);
    setFinished(false);
  }

  function closeChat() {
    setOpen(false);
  }

  return (
    <>
      <button
        type="button"
        className="wa-button"
        onClick={() => setOpen(true)}
        aria-label="פתיחת צ'אט משרד עורכי הדין רז יוסף"
        aria-expanded={open}
      >
        <FaWhatsapp />
      </button>

      {open && (
        <div
          className="chat"
          dir="rtl"
          role="dialog"
          aria-label="צ'אט משרד עורכי הדין רז יוסף"
          aria-modal="false"
        >
          <div className="header2">
            <div className="logoArea">
              <img
                src="/logo192.png"
                alt="משרד עורכי הדין רז יוסף"
                loading="lazy"
              />

              <div className="company-name">
                <span>רז יוסף</span>
                <small>משרד עורכי דין</small>
              </div>
            </div>

            <button
              type="button"
              onClick={closeChat}
              aria-label="סגירת צ'אט"
            >
              <FaTimes />
            </button>
          </div>

          <div
            className="messages"
            ref={messagesRef}
            role="log"
            aria-live="polite"
            aria-relevant="additions"
          >
            {messages.map((msg, index) => (
              <div
                key={index}
                className={
                  msg.type === "bot" ? "bot" : "user"
                }
              >
                {msg.text}
              </div>
            ))}

            {step === 1 && (
              <div className="options">
                {topics.map((topic, index) => (
                  <button
                    key={index}
                    type="button"
                    onClick={() => selectOption(topic)}
                    disabled={processing}
                  >
                    {topic}
                  </button>
                ))}
              </div>
            )}
          </div>

          {step >= 2 && step <= 4 && !finished && (
            <form
              className="inputBox"
              onSubmit={event => {
                event.preventDefault();
                sendMessage();
              }}
            >
              <input
                type="text"
                value={input}
                onChange={event => setInput(event.target.value)}
                placeholder="כתוב הודעה..."
                aria-label="הקלדת הודעה"
                autoComplete="off"
                disabled={processing}
              />

              <button
                type="submit"
                disabled={processing || !input.trim()}
                aria-label="שליחת הודעה"
              >
                <FaPaperPlane />
              </button>
            </form>
          )}

          {finished && (
            <button
              type="button"
              className="sendWA"
              onClick={sendWhatsapp}
              disabled={processing}
            >
              שליחת הפנייה לוואטסאפ
              <FaWhatsapp />
            </button>
          )}
        </div>
      )}
    </>
  );
}
